const QUERY_ORDERS = `
query WebOrders {
  orders(order_type: ToteTransaction, needs_payment: true) {
    id
    overdue_surcharge_tips
    summary {
      purchase_credit
      discount
    }
    created_at
    tote {
      id
      state
      tote_products {
        id
        product_item {
          state
        }
        tote_specific_price
        product {
          activated_at
          id
          full_price
          brand {
            name
          }
          catalogue_photos(limit: 1) {
            thumb_url
          }
        }
      }
    }
    line_items {
      __typename
      ... on ProductLineItem {
        amount
        product {
          activated_at
          charge_scope
          catalogue_photos(limit: 1) {
            full_url
          }
          title
          full_price
          dynamic_price
          id
          parts{
            title
          }
        }
        size {
          abbreviation
          name
        }
      }
    }
  }
}
`

const QUERY_ORDER = `
  query WebOrder($id: ID, $order_number: String) {
    order(id: $id, order_number: $order_number) {
      id
      order_number
      successful
      payment_failed
      title
      title_detail
      created_at
      paid_at
      free_service_fee_tip {
        content
        title
      }
      summary {
        subtotal
        total_amount
      }
      payment {
        gateway
      }
      charge_refund {
        no
        state
        refund_price
      }
    }
  }
`

const QUERY_PAYMENT_PENDING_PREVIEW = `
  query WebPaymentPendingPreview($order_id: ID) {
    multi_tote_transaction_preview(order_id: $order_id) {
      preview {
        final_price
      }
    }
  }
`

export default { QUERY_ORDERS, QUERY_ORDER, QUERY_PAYMENT_PENDING_PREVIEW }
